import { t } from '../../utils/i18n';
import { toastError } from '../../views/components/error';
import { getProcedureStaffByStaffId } from '../../services/procedureServices';
import { APPOINTMENT_REQUEST_CALENDAR, APPOINTMENT_REQUEST_FORM, SCREEN, HOST_TYPE_ONE_ON_ONE, HOST_TYPE_ROUND_ROBIN, HOST_TYPE_COLLECTIVE } from '../../utils/constants';
import {
    setProcedures,
    setProviderId,
    appUrl,
    isInInstantQuote,
    isBookAppointment,
    setCurrentDateInUse,
    procedures,
    selectedGender,
    form,
    dataSlot,
    showBodyAreaSelection,
    bodyAreaSelected,
    staffId,
    procedureIdSelected,
    isDesktopVer,
    setSelectedProcedures,
    selectedProcedures,
    selectedProcedures as currentSelectedProcedureIds,
    appointmentChannelId,
    providerId,
    setSelectedStaffAppointmentChannel,
    shouldCollectPatientInfoFirstForWidget,
    isFlowForCalendar,
    initUI,
    skipInterestPage,
    tempLeadInfo,
    setTempLeadInfo,
    setLeadTextId,
    setLeadInfo,
    leadInfo,
    isAutoSelectSoonestProviderEnabled,
} from '../../utils/variables';
import { selectProvider, getProviderFullName } from '../actions/providerActions';
import { navigate } from './movePages';
import { toggleLoading } from '../actions/loading';
import { loadCategories } from '../../views/components/category';
import { loadProcedures } from '../../views/components/procedures';
import { loadOnlyTimeCarousel, loadTimeCarousel } from '../../views/components/timeSelect';
import { selectOnlyTimeListeners, selectTimeListeners } from './selectTimeListeners';
import { loadSelectSearchProcedure } from '../../views/components/selectSearchProcedure';
import { renderStaffInfoHeader } from '../actions/InfoStaffAppointment';
import { goToServices } from './validateDigitsListeners';
import { handelConsultSummaryBtn } from './consultListeners';
import { createLead } from '../../services/leadServices';

function canUserChooseStaff(hostType, staffCount) {
    // Auto-select soonest provider overrides all host-type rules: the visitor
    // never picks a provider.
    if (isAutoSelectSoonestProviderEnabled()) return false;
    switch (hostType) {
        case HOST_TYPE_ONE_ON_ONE: {
            const isProviderFirst = form?.appointment_channel?.is_select_provider_first;
            return staffCount > 1 && isProviderFirst;
        }
        case HOST_TYPE_ROUND_ROBIN:
        case HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return form?.appointment_channel?.visitor_can_choose_the_staff;
    }
}

function getHostType() {
    return form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
}

export function providerListeners() {
    /* On select provider */
    document.querySelectorAll('.providers__list .provider').forEach((i) => {
        i.addEventListener('click', handleSelectProvider);
    });

    if (isBookAppointment) {
        const titleContent = document.querySelector('.providers__container .title__content');
        if (titleContent) {
            titleContent.innerHTML = t('select_provider');
        }
    }

    /* On click enter */
    const screenProviders = document
        .querySelector('.screen--providers');

    if (screenProviders) {
        screenProviders.addEventListener('keydown', handleScreenProvidersKeyDown);
    }
    /* On click Continue after selected provider */
    document
        .querySelector('.providerContinue__btn')
        .addEventListener('click', handleProviderContinueBtn);
}

export async function handleProviderContinueBtn() {    
    const isConsultationRequest = form.appointment_request_type === APPOINTMENT_REQUEST_FORM;
    const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;
    if (isInInstantQuote) {
        loadCategories(filterProcedures(procedures));
        loadProcedures(filterProcedures(procedures));
        navigate(SCREEN.SEE_ALL_SERVICES);
    } else if (
        isConsultationRequest && isCategoryEnabled
    ) {
        if (tempLeadInfo && !leadInfo) {
            const res = await createLead({
                ...tempLeadInfo,
                ...(providerId && { provider_id: providerId }),
            });
            setLeadTextId(res.data.text_id);
            setLeadInfo(res.data);
            setTempLeadInfo(null);
        }
        handelConsultSummaryBtn();
    } else if (isBookAppointment) {
        const { staffs, procedures: proceduresOfAppointment } = form.appointment_channel

        if (appointmentChannelId && proceduresOfAppointment?.length > 1 && !isFlowForCalendar) {
            const proceduresIds = proceduresOfAppointment?.map(i => i.id)
            const providersOfServices = selectedProcedures?.every(i => proceduresIds?.includes(i))
            if (!providersOfServices) {
                const div = document.querySelector('.notfound__container .screen__content')
                if (div) {
                    div.textContent = t('provider_no_service')
                }
                navigate(SCREEN.NOTFOUND_APPOINTMENT)
                return
            }
        }

        // `!form.appointment_request_type === X` compares a boolean to a string, so
        // it is always false and BOTH blocks below always fell through to
        // renderSelecTime() — running it twice, concurrently, whenever
        // requires_consult === false. The two runs rebuilt the date carousel while
        // the other was binding its click listeners (dead date taps) and raced four
        // navigate() calls (calendar rendered over the times screen). Keep the
        // effective behavior, but run it exactly once.
        renderSelecTime();

    }
}

export async function renderSelecTime() {
    if (appointmentChannelId) {
        // Always use month calendar grid for appointment channel widget flow
        document.querySelector('.selectOnlyDate__container .title__content').innerHTML = `${t('select_time_with')} ${getProviderFullName()}`;
        if (isDesktopVer || (!isDesktopVer && initUI === 'embedded')) {
            document?.querySelector('.selectOnlyDate__container .screen__content')?.style.setProperty('--header-height', '0px')
            document.querySelector('.selectOnlyDate__container .title__wrapper').classList.add("hidden")
        }
        if (!isDesktopVer && initUI === 'embedded') {
            document?.querySelector('.selectOnlyDate__container .infoStaff')?.style.setProperty('display', 'none')
            document?.querySelector('.selectOnlyDate__container .selectOnlyTime__title')?.style.setProperty('padding-top', '1rem')
        }
        toggleLoading(true);
        await loadOnlyTimeCarousel();
        selectOnlyTimeListeners();
        const foundStaff = form?.staff?.find(staff => staff.id === (+staffId) || providerId);
        const foundProcedure = procedures.find(p => p?.id === +procedureIdSelected)
        renderStaffInfoHeader(foundStaff, foundProcedure, 'selectOnlyDate__container')
        navigate(SCREEN.SELECT_ONLY_DATE);
        toggleLoading(false);
        return;
    }

    // Legacy non-appointmentChannel flows — keep existing behavior
    if (shouldCollectPatientInfoFirstForWidget) {
        setCurrentDateInUse(moment().unix());
        toggleLoading(true);
        await loadTimeCarousel();
        selectTimeListeners();
        document.querySelector('.selectTime__container .title__content').innerHTML = `${t('select_time_with')} ${getProviderFullName()}`;
        navigate(SCREEN.SELECT_TIME);
        toggleLoading(false);

    } else {
        if (staffId && procedureIdSelected || (appointmentChannelId && form?.appointment_channel?.procedures?.length > 1)) {
            document.querySelector('.selectOnlyDate__container .title__content').innerHTML = `${t('select_time_with')} ${getProviderFullName()}`;
            if (isDesktopVer || (!isDesktopVer && initUI === 'embedded')) {
                document?.querySelector('.selectOnlyDate__container .screen__content')?.style.setProperty('--header-height', '0px')
                document.querySelector('.selectOnlyDate__container .title__wrapper').classList.add("hidden")
            }

            if (!isDesktopVer && initUI === 'embedded') {
                document?.querySelector('.selectOnlyDate__container .infoStaff')?.style.setProperty('display', 'none')
                document?.querySelector('.selectOnlyDate__container .selectOnlyTime__title')?.style.setProperty('padding-top', '1rem')
            }

            toggleLoading(true);
            await loadOnlyTimeCarousel();
            selectOnlyTimeListeners();
            const foundStaff = form?.staff?.find(staff => staff.id === (+staffId) || providerId);
            const foundProcedure = procedures.find(p => p?.id === +procedureIdSelected)
            renderStaffInfoHeader(foundStaff, foundProcedure, 'selectOnlyDate__container')
            navigate(SCREEN.SELECT_ONLY_DATE);
            toggleLoading(false);
        } else {
            document.querySelector('.selectTime__container .title__content').innerHTML = `${t('select_time_with')} ${getProviderFullName()}`;
            navigate(SCREEN.SELECT_TIME);
        }

    }
}

async function handleScreenProvidersKeyDown(event) {
    if (event.key === 'Enter' && !document.querySelector('.providerContinue__btn').classList.contains('disabled--noneOpacity')) {
        document.querySelector('.providerContinue__btn').click();
    }
}

export async function fetchProcedureByStaff(providerId) {
    let selectedProcedures = [];

    try {
        const res = await getProcedureStaffByStaffId(providerId);
        res.data.data.forEach((procedureStaff) => {
            if (procedureStaff.procedure) {
                selectedProcedures.push(procedureStaff.procedure);
            }
        });

        selectedProcedures.forEach((proce) => {
            const addOns = res.data.data.find(
                (item) => item?.procedure?.id === proce?.id
            )?.procedure_addons;
            proce.procedure_addons = addOns;
        });

        if (appointmentChannelId && form?.appointment_channel?.procedures?.length > 0) {
            const proceduresOfAppointmentChannelIds = form?.appointment_channel?.procedures?.map(i => i.id);
            const proceduresOfAppointmentChannelSelected = selectedProcedures.filter(i => proceduresOfAppointmentChannelIds.includes(i.id));
            selectedProcedures = proceduresOfAppointmentChannelSelected;
            if (proceduresOfAppointmentChannelSelected.length === 1) {
                setSelectedProcedures([proceduresOfAppointmentChannelSelected[0].id]);
            } else if (proceduresOfAppointmentChannelSelected.length === 0) {
                // A 0-match intersection (staff→procedure mapping doesn't list
                // the channel's services, or a partial API response) must NOT
                // clobber a selection that is already valid for this channel —
                // wiping it here made single-selection bookings submit the
                // whole menu and 422 ("Please select a service to book.").
                const stillValid = (currentSelectedProcedureIds || [])
                    .filter((id) => proceduresOfAppointmentChannelIds.includes(+id));
                if (!stillValid.length) {
                    setSelectedProcedures([]);
                }
            }
        }
    } catch (err) {
        toastError(err.response?.data?.message || t('server_error_generic'));
    }

    setProcedures(selectedProcedures);
    loadProcedures(selectedProcedures);
    loadCategories(selectedProcedures);
}

export async function handleSelectProvider(e = null, selectedProvider = null) {
    let className =
        e && !e.currentTarget?.classList.contains('provider')
            ? e.currentTarget.className
            : 'providerContinue__btn';
    let isLoading = document
        .querySelector(`.${className}`)
        ?.classList?.contains('disabled--noneOpacity');
    if (isLoading && !appointmentChannelId) {
        return;
    }
    const hostType = getHostType();
    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
    const staffCount = staffsOfAppointmentChannel?.length || 0;
    const canChooseStaff = canUserChooseStaff(hostType, staffCount);
    const isProviderFirst = form?.appointment_channel?.is_select_provider_first;


    let providerIdCurrent =
        (appointmentChannelId && canChooseStaff && isProviderFirst) ? providerId ?? parseInt(this.getAttribute('data-provider-id')) : staffId || selectedProvider || parseInt(this.getAttribute('data-provider-id'));
    !((staffId || selectedProvider) && !canChooseStaff) && selectProvider(providerIdCurrent);
    setProviderId(providerIdCurrent);

    if (appointmentChannelId && (canChooseStaff || !isProviderFirst)) {
        if (typeof this?.getAttribute === 'function') {
            const id = parseInt(this.getAttribute('data-provider-id'));
            if (id !== providerIdCurrent) {
                providerIdCurrent = id
                setProviderId(id);
                selectProvider(id)
            }
        }
        setSelectedStaffAppointmentChannel(providerIdCurrent)
    }

    let loaderIcon = null;

    document
        .querySelector(`.${className}`)
        ?.classList.add('disabled--noneOpacity');
    document
        .querySelector(`.${className} .loading__wrapper`)?.classList.remove('hidden');
    loaderIcon = document.querySelector(`.${className} .loader__icon`);
    if (loaderIcon) {
        loaderIcon.innerHTML = '';
        loaderIcon.insertAdjacentHTML('beforeend', `<img src="${appUrl}/assets/icons/rolling.png" />`);
        document.querySelector('.providerBack__btn').classList.add('disabled');
    }


    const isConsultationRequest = form.appointment_request_type === APPOINTMENT_REQUEST_FORM;
    const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;

    if (isConsultationRequest && isCategoryEnabled) {
        if (tempLeadInfo && !leadInfo) {
            const res = await createLead({
                ...tempLeadInfo,
                ...(providerIdCurrent && { provider_id: providerIdCurrent }),
            });
            setLeadTextId(res.data.text_id);
            setLeadInfo(res.data);
            setTempLeadInfo(null);
        }
        handelConsultSummaryBtn();
    } else if (isInInstantQuote) {
        await fetchProcedureByStaff(providerIdCurrent);
        const foundProcedure = procedures?.find(i => i?.id === +procedureIdSelected)
        if (procedureIdSelected && foundProcedure) {
            let proceduresArr = [...selectedProcedures, foundProcedure.id];
            setSelectedProcedures(proceduresArr);
            if (skipInterestPage) {
                navigate(SCREEN.FULL_NAME);
                setTimeout(() => {
                    const fullNameInput = document.getElementById('fullName');
                    if (fullNameInput !== document.activeElement) {
                        fullNameInput.focus();
                    }
                }, 500);
            } else {
                navigate(SCREEN.INTERESTS);
            }
        } else {
            loadCategories(filterProcedures(procedures));
            loadProcedures(filterProcedures(procedures));
            // skip Continue screen when send staff_id in params
            staffId && navigate(SCREEN.SEE_ALL_SERVICES);
        }
    } else if (isBookAppointment || (appointmentChannelId)) {
        if (staffId && !canChooseStaff) {
            setProviderId(+staffId)
        }

        if (appointmentChannelId && (canChooseStaff)) {
            if (typeof this?.getAttribute === 'function') {
                const id = parseInt(this.getAttribute('data-provider-id'));
                if (id !== providerIdCurrent) {
                    providerIdCurrent = id
                    setProviderId(id);
                    selectProvider(id)
                }
            }
        }

        if (!isProviderFirst) {
            if (typeof this?.getAttribute === 'function') {
                const id = parseInt(this.getAttribute('data-provider-id'));
                providerIdCurrent = id
                setProviderId(id);
                selectProvider(id)
            }
        }
        if (appointmentChannelId && isProviderFirst && providerIdCurrent !== -1) {
            await fetchProcedureByStaff(providerIdCurrent);
        }

        if (canChooseStaff && form?.appointment_channel?.procedures?.length > 1 && appointmentChannelId) {
            document
                .querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                document.querySelector('.providerBack__btn').classList.remove('disabled');
            }
            document
                .querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');
            goToServices()
            return
        }

        if (appointmentChannelId) {
            await renderSelecTime();
            // Remove loading state (same as end of function)
            document.querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                document.querySelector('.providerBack__btn').classList.remove('disabled');
            }
            document.querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');
            return;
        }
        setCurrentDateInUse(moment().unix());
        await loadTimeCarousel();
        selectTimeListeners();
    }

    document
        .querySelector(`.${className}`)?.classList.remove('disabled--noneOpacity');
    if (loaderIcon) {
        loaderIcon.innerHTML = '';
        loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        document.querySelector('.providerBack__btn').classList.remove('disabled');
    }
    document
        .querySelector(`.${className} .loading__wrapper`)?.classList.add('hidden');


}

export function filterProcedures(proce) {
    let currentProcedures = proce;
    if (showBodyAreaSelection && bodyAreaSelected?.length > 0) {
        currentProcedures = proce?.filter(item => checkCategoryOfProcedure(item.service_categories.map(category => category.name)));
    }
    if (!selectedGender) {
        return currentProcedures.filter(procedure => {
            return procedure.online_booking;
        });
    }
    let newProcedures = currentProcedures.filter(procedure => {
        return (procedure.gender === selectedGender || procedure.gender === 'both') && procedure.online_booking;
    });
    return newProcedures;
}

const checkCategoryOfProcedure = (categories) => {
    const listCategory = bodyAreaSelected?.map(item => item.name);
    return listCategory.some(item => categories.includes(item));
};
